import { ApplicationConfig, importProvidersFrom, inject, provideAppInitializer } from '@angular/core';
import { provideRouter, withEnabledBlockingInitialNavigation } from '@angular/router';
import { routes } from './app.routes';
import { AuthService } from './services/auth/auth.service';
import { en_US, provideNzI18n } from 'ng-zorro-antd/i18n';
import { registerLocaleData } from '@angular/common';
import en from '@angular/common/locales/en';
import { FormsModule } from '@angular/forms';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { provideAngularSvgIcon } from 'angular-svg-icon';
import { NzModalService } from 'ng-zorro-antd/modal';
import { provideHighcharts } from 'highcharts-angular';
import { accessTokenInterceptorProvider } from './shared/interceptor/access-token.interceptor';
import { provideAnimations } from '@angular/platform-browser/animations';
registerLocaleData(en);

export const appConfig: ApplicationConfig = {
  providers: [
    // Both of these are app initializers, so they start together and bootstrap waits for both.
    // Auth therefore resolves before the first render, and so does the initial route — the app
    // shell reads the router URL to decide whether to render (see GainsLayoutComponent), and
    // would otherwise paint the sidenav while the URL is still '/'.
    provideRouter(routes, withEnabledBlockingInitialNavigation()),
    provideAppInitializer(() => inject(AuthService).init()),
    accessTokenInterceptorProvider,
    provideAnimations(),
    provideNzI18n(en_US),
    importProvidersFrom(FormsModule),
    provideHttpClient(withInterceptorsFromDi()),
    provideAngularSvgIcon(),
    provideHighcharts({
      modules: () => {
        return [
          import('highcharts/esm/modules/offline-exporting'),
          import('highcharts/esm/modules/accessibility'),
          import('highcharts/esm/modules/exporting'),
          import('highcharts/esm/modules/export-data'),
          import('highcharts/esm/themes/sunset'),
          import('highcharts/esm/modules/heatmap'),
          import('highcharts/esm/modules/treemap'),
          import('highcharts/esm/modules/pareto')
        ];
      }
    }),
    NzModalService
  ]
};
